import {connect} from 'react-redux';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import LikeButton, {LikeButtonProps} from './LikeButton';
import CommentModel from '../../types/CommentModel';

const mapStateToProps = (state: ReduxState, ownProps: LikeButtonContainerProps): Partial<LikeButtonProps> => {
   return {
      comment: ownProps.comment,
      userId: state.currentUser && state.currentUser.userId,
      themeName: state.themeName
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<LikeButtonProps> => {
   return {
      setModalState: modalState => {
         dispatch(Action.setModalState({modalState: modalState}));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(LikeButton);

export interface LikeButtonContainerProps {
   comment: CommentModel;
}
